export default "__VITE_ASSET__C8n1el21__"